



























































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {alert} from 'devextreme/ui/dialog';

import DButton from '@/components/DButton/button.vue';
import DTextbox from '@/components/DTextbox/textbox.vue';
import DSelectbox from '@/components/DSelectbox/selectbox.vue';
import DSwitch from '@/components/DSwitch/switch.vue';
import DTagbox from '@/components/DTagbox/tagbox.vue';

import DxPopup from 'devextreme-vue/popup';
import DxScrollView from 'devextreme-vue/scroll-view';
import { DxValidationGroup } from 'devextreme-vue';

import _ from 'lodash';
import UserManagerService, { User } from '@/services/data/user_manager';
import RoleManagerService from '@/services/data/role_manager';
import AuthService from '@/services/auth_service';
import DictCacheService from '@/services/dicts_cache_service';
import { validationRegexp } from '@/utils/validate';
import DxSelectBox from "devextreme-vue/select-box";
import FlatDropDownBox from "@/components/TreeDropDownBox/flat-drop-down-box.vue"
import { EcoFilialSelectionType } from '@/services/models-service';
import TreeDropDownBox from '@/components/TreeDropDownBox/tree-drop-down-box.vue';


@Component({
  name: 'UserEditPopup',
  components: {
    DxSelectBox,
    DxPopup,
    DxScrollView,
    DxValidationGroup,
    DTextbox,
    DButton,
    DSelectbox,
    DSwitch,
    DTagbox,
    FlatDropDownBox,
    TreeDropDownBox
  }
})

export default class extends Vue {
  @Prop() heatNodesDs!: any;
  @Prop() filialsDs!: any;
  @Prop() nodeFilialMap!: any;
  @Prop({default: () => []}) selectionEmpty!: EcoFilialSelectionType[];

  public service = UserManagerService;
  public authService = AuthService;
  public dictCacheService = DictCacheService;
  public entity: User = new User();

  public filial_id: any = null;
  public regexp = validationRegexp;

  // Источник данных для списка ролей пользователя
  private roleDataSource = RoleManagerService.dataSource;

  // Флаг изменения пароля при редактировании учетки пользователя
  private showPasswordOnEdit = false;
  private storage_access = '';
  public admin_selected: boolean = false;

  private selectionData: EcoFilialSelectionType[] = [];

  private fileManagerOptions = [
    { id: 'forbidden', name: 'Запрещен доступ' },
    { id: 'read_only', name: 'Разрешен только просмотр' },
    { id: 'read_and_edit', name: 'Разрешен просмотр и редактирование' }
  ];

  get adminSelected() {
    return this.admin_selected;
  }

  get isPasswordInputVisible() {
    return (this.service.edit_popup.edit_mode) ? this.showPasswordOnEdit : true;
  }

  nodeSelectionChange(nodeIds: any) {
    this.entity.eco_heat_nodes = nodeIds.nodes;
  }
  


  @Watch('entity.id_eco_heat_node')
  watchFilial() {
    this.getFilialForNode();
  }

  @Watch('entity.role')
  watchRole() {
    if (this.entity.role === this.authService.adminRoleId) {
      this.admin_selected = true;
      this.entity.id_eco_heat_node = null;
      this.filial_id = null;
    } else {
      this.admin_selected = false
    }
  }

  // async created() {
  //   if (this.service.edit_popup.edit_mode) {
  //     this.entity = _.cloneDeep(this.service.selected_row);
  //     let heat_nodes = _.clone(this.entity.eco_heat_nodes);

  //     this.entity.eco_heat_nodes = [];
  //     if (heat_nodes && heat_nodes.length > 0) {
  //       heat_nodes.forEach((x: any) => {
  //         this.entity.eco_heat_nodes.push(x.id_eco_heat_node)
  //       })
  //     }

  //     this.showPasswordOnEdit = false;
  //     this.getFilialForNode();

  //   } else {
  //     this.entity = new User();
  //     this.filial_id = null;
  //   }
  // }
  async created() {
    if (this.service.edit_popup.edit_mode) {
      this.showPasswordOnEdit = false;
      this.entity = _.cloneDeep(this.service.selected_row);
      this.entity.eco_heat_nodes = this.service.selected_row.eco_heat_nodes.map((x: any): number => x.id_eco_heat_node)
      this.selectionData = this.selectionEmpty.map(sel => {
        let filialCheck = true; // Сосотояние "выбран" для узла верхнего уровня дерева - филиала
        const nodes = sel.nodes.map( n => {
          if (this.entity.eco_heat_nodes.includes(n.id)) {
            return { ...n, check: true };
          } else {
            // Если хотя бы 1 узел в филиале не выбран, для него указывается состояние "не выбран"
            filialCheck = false;
            return { ...n, check: false };
          }
        });
        return { ...sel, filialCheck, nodes };
      })
    } else {
      this.entity = new User();
      this.selectionData = _.cloneDeep(this.selectionEmpty);
    }
  }

  getFilialForNode() {


    if (this.entity.id_eco_heat_node) {
      this.filial_id = this.nodeFilialMap[this.entity.id_eco_heat_node];
    }
  }

  async onShow() {


  }

  onClose() {
    this.service.setEditPopupVisible(false);
    this.service.setEditPopupMode(false);
  }

  async onOk(e: any) {
    const vg = (this.$refs['userEditForm'] as any).instance;
    const result = vg.validate();
    if (result.isValid) {
      try {

        if (!this.admin_selected && (_.isNil(this.entity.eco_heat_nodes) || this.entity.eco_heat_nodes.length === 0)) {
          await alert("Для оператора необходимо указать тепловые узлы", 'Ошибка');
          return;
        }

        const clone: any = _.cloneDeep(this.entity)
        if (clone.eco_heat_nodes && clone.eco_heat_nodes.length !== 0) {
            let eco_heat_nodes: any = _.clone(clone.eco_heat_nodes);

            clone.eco_heat_nodes = [];
            eco_heat_nodes.forEach((x: any) => {
              clone.eco_heat_nodes.push({id_eco_heat_node: x})
            })
        }
        const resp = await this.service.saveUser(clone);
        try { await this.service.userDataSource.reload(); } catch (e) { if (e !== 'canceled') throw e; }
        this.service.setCurrentRow(null);
        this.onClose();

      } catch (e) {
        console.log(e)
      }
    } else {
      const errors = result.brokenRules.map((item: any) => item.message);
      if (errors.length > 0) {
        await alert(errors.join('<br>\n'), 'Ошибка');
      }
    }
  }

}
